import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../Utility';
import { updateUserDatabase } from '../actions';

const initialState = {
    currentUser: null,
    emailVerified: false,
    currentId: null,
    userList: {}
};



const authSuccess = (state, action) => {
    return updateObject(state, { currentUser: action.user, currentId: action.id })
}

const emailNotVerified = (state, action) => {
    return updateObject(state, { emailVerified: false })
}

const emailVerified = (state, action) => {
    return updateObject(state, { emailVerified: true });
}

const logOut = (state, action) => {
    return updateObject(state, { currentUser: null, emailVerified: false, currentId: null })
}

const usersFound = (state, action) => {
    return updateObject(state, { userList: action.userList });
}

const updateUserList = (state, action) => {
    const updatedObject = { ...state.userList };
    updatedObject[action.id] = action.user;
    return updateObject(state, { userList: updatedObject });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.EMAIL_NOT_VERIFIED: return emailNotVerified(state, action);
        case actionTypes.EMAIL_VERIFIED: return emailVerified(state, action);
        case actionTypes.USERS_FOUND: return usersFound(state, action);
        case actionTypes.LOGOUT: return logOut(state, action);
        case actionTypes.UPDATE_USER_LIST: return updateUserList(state, action);
        default: return state;
    }
}

export default reducer;